export class AllocationRequest {
	constructor() {	}
} 
